var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"chart",style:({ 'height': _vm.height + 'px' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }